// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__EPGB+","logoContainer":"Sidebar_logoContainer__awZlW"};